export default __webpack_public_path__ + "static/media/courier-tracking-small-van.d3ae17bb.svg";